import { createTheme } from "@aws-amplify/ui-react";

export const theme = createTheme({
  name: "ESGO Theme",

  tokens: {
    colors: {
      background: {
        primary: { value: "#ffffff" },
        secondary: { value: "#f8fafc" },
      },

      font: {
        primary: { value: "#0f172a" },
        secondary: { value: "#475569" },
        tertiary: { value: "#94a3b8" },
        interactive: { value: "#2563eb" },
      },

      border: {
        primary: { value: "#e2e8f0" },
        secondary: { value: "#cbd5e1" },
        focus: { value: "#2563eb" },
      },

      brand: {
        primary: {
          10:  { value: "#eff6ff" },
          20:  { value: "#dbeafe" },
          40:  { value: "#93c5fd" },
          60:  { value: "#2563eb" },
          80:  { value: "#1d4ed8" },
          100: { value: "#1e3a8a" },
        },
      },

      overlay: {
        5:  { value: "rgba(15,23,42,0.05)" },
        10: { value: "rgba(15,23,42,0.10)" },
        20: { value: "rgba(15,23,42,0.20)" },
        30: { value: "rgba(15,23,42,0.30)" },
        40: { value: "rgba(15,23,42,0.40)" },
        50: { value: "rgba(15,23,42,0.50)" },
        60: { value: "rgba(15,23,42,0.60)" },
        70: { value: "rgba(15,23,42,0.70)" },
        80: { value: "rgba(15,23,42,0.80)" },
        90: { value: "rgba(15,23,42,0.90)" },
      },
    },

    radii: {
      xs:     { value: "4px" },
      small:  { value: "8px" },
      medium: { value: "12px" },
      large:  { value: "16px" },
      xl:     { value: "24px" },
    },

    shadows: {
      small:  { value: "0 1px 3px rgba(15,23,42,0.08), 0 1px 2px rgba(15,23,42,0.06)" },
      medium: { value: "0 4px 16px rgba(15,23,42,0.10), 0 2px 6px rgba(15,23,42,0.06)" },
      large:  { value: "0 20px 50px rgba(15,23,42,0.12), 0 8px 20px rgba(15,23,42,0.07)" },
    },

  },
});